import {
  EXAM_CENTER_MEMBER_STATUS_COLOR,
  EXAM_CENTER_MEMBER_STATUS_TEXT,
  UserAvatar,
  type ExamCenterMemberStatus,
} from '@exam-center/exam-center-member-details';
import { ChipGroup, Flex, Label, Text, type GridColDef } from '@shared/components';

interface AddExamCenterMemberRow {
  fullName: string;
  email: string;
  role: string[];
  status: ExamCenterMemberStatus;
}

export const columns: GridColDef<AddExamCenterMemberRow>[] = [
  {
    field: 'name',
    headerName: 'Name',
    sortable: false,
    flex: 1,
    renderCell: (params) => {
      const { fullName, email } = params.row;
      return (
        <Flex sx={{ gap: (theme) => theme.spacing(3), alignItems: 'center' }}>
          <UserAvatar fullName={fullName} email={email} />
          <Flex sx={{ flexDirection: 'column' }}>
            <Text variant='body1Semibold'>{fullName}</Text>
            <Text variant='body2' color='textSecondary'>
              {email}
            </Text>
          </Flex>
        </Flex>
      );
    },
  },
  {
    field: 'role',
    headerName: 'Role',
    sortable: false,
    width: 240,
    renderCell: (params) => {
      const { role } = params.row;
      return <ChipGroup labels={role} limit={2} />;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: false,
    width: 120,
    renderCell: (params) => {
      const status = params.row.status;
      return (
        <Label size='large' color={EXAM_CENTER_MEMBER_STATUS_COLOR[status]}>
          {EXAM_CENTER_MEMBER_STATUS_TEXT[status]}
        </Label>
      );
    },
  },
];
